import React from 'react';
import { useTranslations } from 'next-intl';
import { featureBookingModalConfig } from '@/shared/config/tests/e2e/features/booking';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/shared/ui/select';
interface Props {
  value: string;
  onOpenChange?: (value: boolean) => void;
  onValueChange: (value: string) => void;
}
export const BookingTimeSelect: React.FC<Props> = props => {
  const {
    value,
    onOpenChange,
    onValueChange
  } = props;
  const t = useTranslations();
  const handleContentClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  return <Select onOpenChange={onOpenChange} value={value} onValueChange={onValueChange} data-sentry-element="Select" data-sentry-component="BookingTimeSelect" data-sentry-source-file="BookingTimeSelect.tsx">
      <SelectTrigger className="w-full" data-testid={featureBookingModalConfig.ids.bookingTimeSelectTrigger} data-sentry-element="SelectTrigger" data-sentry-source-file="BookingTimeSelect.tsx">
        <SelectValue active={value !== ''} placeholder={t('bookingPage.preferredTime.recording_date')} data-sentry-element="SelectValue" data-sentry-source-file="BookingTimeSelect.tsx" />
      </SelectTrigger>
      <SelectContent onClick={handleContentClick} data-sentry-element="SelectContent" data-sentry-source-file="BookingTimeSelect.tsx">
        <SelectItem data-testgroup={'booking-time-select-option'} value={t('bookingPage.preferredTime.today')} data-sentry-element="SelectItem" data-sentry-source-file="BookingTimeSelect.tsx">
          {t('bookingPage.preferredTime.today')}
        </SelectItem>
        <SelectItem data-testgroup={'booking-time-select-option'} value={t('bookingPage.preferredTime.next_days')} data-sentry-element="SelectItem" data-sentry-source-file="BookingTimeSelect.tsx">
          {t('bookingPage.preferredTime.next_days')}
        </SelectItem>
        <SelectItem data-testgroup={'booking-time-select-option'} value={t('bookingPage.preferredTime.weekend')} data-sentry-element="SelectItem" data-sentry-source-file="BookingTimeSelect.tsx">
          {t('bookingPage.preferredTime.weekend')}
        </SelectItem>
      </SelectContent>
    </Select>;
};